<template>
  <v-container fluid>
    <v-alert type="warning" max-width="600" icon="mdi-alert-octagon" class="mx-auto mt-5 material-icons-outlined" dark
      prominent>
      <h2>Licence required.</h2>
      You can contact Qwips support by email to support@qwips.no if you are interested in getting a licence for use of
      this page.
      <!-- 
        //TODO: make licence information page here where they can see what the licence offers and link to about page for licence overview. 
        Im not gonna translate the text here for now as the text will be depricated when this is done. 
      -->
    </v-alert>
  </v-container>
</template>


<script>
export default {
  name: 'UnLicencedAccess',
  props: {},
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>